import BreadcrumbComponent from '@components/common/Breadcrumb';
import LeftNavBarCommon from '@pages/AppWrapperViewComponent/LeftNavBarCommon';
import NationalEmblem from '../../../assets/svg_main/national_emblem.svg';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import './Child/ChildComponent.css';
import BadgesComponent from '@components/common/Badges';
import { CommonHamburgar } from '@components/common/CommonHamburgar';
import Button from '../../../components/common/Button';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import BackArrowsvg from '../../../assets/svg_main/BackArrowIconSvg.svg';
import profilePic from '../../../assets/png/default_profile.png';
import endpoints from '@config/endpoints';
import convertByteToImageURL from '../../../utils/convertByteToImageURL';
import Pencil from '../../../assets/svg/pencil.svg';
import BeneficiaryEdit, { ChildComponentHandlerUpdateBeneficiary } from './edit/BeneficiaryEdit';
import ChildHomeLayout from './Child/ChildHomeLayout';

import BeneficiaryView from './view/BeneficiaryView';
import { getData, getDataWithCache, postDataJSON } from '../../../services/CommonApiService';
import CloseModal from './edit/closeModal';
import { imageData, isImageEdited, isBeneficiaryModified, setAncPregBackHandler, updateAncService, setFamilyPlanningBackHandler, updatePNC, setLmpDate, setShowServices, setShowPregnancy, setPregnancyOngoing, setIsHRP, setBeneficiaryDetails, setIsPregnant, setBenfDeathDetails, updateChild, updateChildDetails, setReferralModule, setLifeCalendarPageMenu, updateChildVerifyFromGrid, setBeneficiaryPregnancyHistory, setBeneficiaryImage, setHrpStatus, setPregnancyDetails, setChildBenefList, setBeneficiaryObstetricHistory, setCheckIsHrp } from '@store/actions/beneficiaryAction';

import { RootState } from '@store/reducers';
import MCPCardDetails from './MCPCard/MCPCardDetails';
import ProfilePicUpdateModal from './Child/ProfilePicUpdateModal';
import { PagePermission } from '../../../services/usePermission';
import {
  beneficiariesTabs,
  benfTabs,
  childTabs,
  referralTabPermission,
} from '@constants/appConstants';
import PregnancyTracking from './PregnancyTracking';
import HRPTracking from './HRP/HRPTracking';
import FamilyPlanning from './FamilyPlanning';
import { errorLogger } from '@utils/applicationLogUtils';
import Unauthorised from '@components/Auth/Unauthorised';
import { decodeWithKeyAndShift } from '@utils/base64Utils';
import { setGoToServices, setListPageType, setShowDueList, setShowDueListFromMainPage } from '@store/actions/eventExecutionAction';
import ReferralOverview from './FacilityReferral/ReferralOverview';
import dayjs from 'dayjs';
import { getOrdinalSuffix } from '@utils/ordinalSuffix';
import { COMMON_CONSTANTS, dateFormate, GENDER } from '@constants/index';
import {
  AddDaystoDate,
  desiredFormatDate,
  diffInYears,
  formatMonthText,
  gender,
} from '@utils/commonUtils';
import { MODULE_CODES, PAGE_CODES } from '@constants/moduleAndPageCodes';
import ChildDetailsView from './Child/ChildDetailsView';
import ChildServices from './Services';
import BenificiaryActions from './view/BenificiaryActions';
import ChildList from './Child/ChildList';
import { updateForm } from '@store/actions/userManagementAction';
import ChildImmunization from './Child/Immunization';
import { toast } from 'react-toastify';
import axios from 'axios';
import Auth from '@utils/auth';
import { CHILD_COMMON_CONSTANTS } from './Child/ChildtrackingConstant';
import { PNC_COMMON_CONSTANTS } from './PNC/PNCConstants';
import ChildBeneficiaryEdit from './Child/ChildBeneficiaryEdit';
import useNavigateWithMenuItem from '@components/common/CustomHooks/useNavigateWithMenuItem';
import LineCalendarComponent from './LifeCalendar';
import PoshanComponent from '../Poshan';
import { useServiceRuleMaster } from '@hooks/useServiceRuleMaster';
import beneficiaryReduxStoreRemovalUtils from '@utils/beneficiaryReduxStoreRemovalUtils';
import JSSKServices from './JSSK';
interface ChildProps {
  page: string;
  flow: string;
}

const WomenComponent = (props: ChildProps) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const childRef = useRef<ChildComponentHandlerUpdateBeneficiary | null>(null);
  const childEditRef = useRef<ChildComponentHandlerUpdateBeneficiary | null>(
    null,
  );
  const { page, flow } = props;
  const [beneficiary, setBeneficiary] = useState<any>();
  const [showUnauthorized, setShowUnauthorized] = useState<boolean>(false);
  const [currentTab, setCurrentTab] = useState('Overview');
  const [imageError, setImageError] = useState('');
  const [newImageUrl, setNewImageUrl] = useState<string>('');
  const inputRef = useRef<any>(null);
  const previousPregnancyLoadedFromLifeCalRef = useRef<boolean>(false);
  const { pathname } = useLocation();
  const [inputField, setInputField] = useState(false);
  const [imageURL, setImageURL] = useState<string>('');
  const [beneficiaryType, setBeneficiaryType] = useState<string>('');
  const pregnancyId = useSelector(
    (state: RootState) => state.beneficiary.currPregnancyId,
  );
  const closeModal = useSelector(
    (state: RootState) => state.beneficiary.showCloseModal,
  );
  const beneficiaryEdited = useSelector(
    (state: RootState) => state.beneficiary.isBeneficiaryModified,
  );
  const { id } = useParams();
  const dispatch = useDispatch();

  const canViewChild = PagePermission(
    MODULE_CODES.BENEFICIARY_CHILD,
    PAGE_CODES.CHILD_OVERVIEW,
  );
  const canViewServices = PagePermission(
    MODULE_CODES.BENEFICIARY_SERVICE,
    PAGE_CODES.SERVICE_OVERVIEW,
  );
  const canViewBenf = PagePermission(
    MODULE_CODES.BENEFICIARY_MODULE,
    PAGE_CODES.BENEFICIARY_OVERVIEW,
  );
  const benfDetails = useSelector(
    (state: RootState) => state.beneficiary.beneficiaryDetails,
  );
  const beneficiaryPregnancyHistory = useSelector(
    (state: RootState) => state.beneficiary.beneficiaryPregnancyHistory,
  );
  const benefPregnancyDetails = useSelector(
    (state: RootState) => state.beneficiary.pregnancyDetails,
  );
  const hrpStatus = useSelector(
    (state: RootState) => state.beneficiary.hrpStatus,
  );
  const beneficiaryImage = useSelector(
    (state: RootState) => state.beneficiary.beneficiaryImage,
  );
  const beneficiaryAllDetails = benfDetails[0];
  const ancPregBackObj = useSelector(
    (state: RootState) => state.beneficiary.ancPregnancyBackhandler,
  );
  const checkIsHRP = useSelector(
    (state: RootState) => state.beneficiary.checkIsHRP,
  );
  const isHRP = useSelector((state: RootState) => state.beneficiary.isHRP);
  const familyPlanningBackObj = useSelector(
    (state: RootState) => state.beneficiary.familyPlanningBackHandler,
  );
  const eventExecution = useSelector((state: RootState) => state.eventExution);
  const workPlan = useSelector((state: RootState) => state.workPlan);
  const [benefDeathDetails, setBenefDeathDetails] = useState<any>([]);
  const viewPregnancyDetails = useSelector(
    (state: RootState) => state?.beneficiary?.viewPregnancyDetails,
  );
  const isChild = useSelector(
    (state: RootState) => state?.beneficiary?.isChild,
  );
  const [loading, setLoading] = useState<boolean>(true);
  const userDetails = localStorage.getItem('userDetails');
  const throughParentProfile = useSelector((state: RootState) => state?.beneficiary?.throughParentProfile,);
  const throughReferralModule = useSelector((state: RootState) => state?.beneficiary?.throughReferralModule,);
  const decodedUserData = JSON.parse(decodeWithKeyAndShift(userDetails));
  const isPregnant = useSelector(
    (state: RootState) => state?.beneficiary?.isPregnant,
  );
  const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);
  const beneficiaryUpdateDetails = useSelector((state: RootState) => state.beneficiary.beneficiaryUpdateDetails);
  const benfImageUrl = useSelector((state: RootState) => state.beneficiary.imageUrl);
  const isImageModified = useSelector(
    (state: RootState) => state.beneficiary.isImageEdited,
  );
  const imageDetails = useSelector(
    (state: RootState) => state.beneficiary.imageData,
  );
  const pageMenuFromLifeCalendar = useSelector(
    (state: RootState) => state?.beneficiary?.pageMenuFromLifeCalendar,
  );
  const beneficiaryObstetricHistory = useSelector(
    (state: RootState) => state.beneficiary.beneficiaryObstetricHistory,
  );
  const [isBackButtonClicked , setBackButtonClicked] = useState(false);
  const [beneficiaryViewProp, setBeneficiaryViewProp] = useState<any>({
      pregnancyHistoryDetails: null,
      pregnancyDetails: null,
      beneficiaryDetails: null,
    });
  const [obstetricHistoryData, setObstetricHistoryData] = useState<any[]>([]);
  const [isHRPStatusUseEffectTrigger, setIsHRPStatusUseEffectTrigger] = useState<boolean>(false);
  const { 
    config: hrpConditionsConfig, 
    loading: hrpConditionsLoading, 
    error: hrpConditionsError
  } = useServiceRuleMaster('hrp-rules');

  const navigateWithMenuItem = useNavigateWithMenuItem();
  useEffect(() => {
    if (ancPregBackObj) {
      setCurrentTab(ancPregBackObj?.menuItems);
    } else if (familyPlanningBackObj) {
      setCurrentTab(familyPlanningBackObj?.menuItems);
    }
    fetchInitialData(isBackButtonClicked);
    dispatch(setCheckIsHrp(!checkIsHRP));

    if (
      eventExecution?.goToServices?.benfId &&
      eventExecution?.goToServices?.benfId === id
    ) {
      dispatch(
        setGoToServices({
          isFromVhnd: true,
          benfId: eventExecution?.goToServices?.benfId,
        }),
      );
    } else {
      dispatch(
        setGoToServices({
          isFromVhnd: false,
          benfId: eventExecution?.goToServices?.benfId,
        }),
      );
    }
    if (isBackButtonClicked) {
    setBackButtonClicked(false);
  }
  }, [isBackButtonClicked]);

  useEffect(() => {
    isHRPStatusUseEffectTrigger && ancPregBackObj && handleChildOverview();
  }, [ancPregBackObj]);

  useEffect(() => {    
    setNewImageUrl(benfImageUrl || '');
  }, [benfImageUrl]);

  useEffect(() => {
    if (pageMenuFromLifeCalendar && pageMenuFromLifeCalendar?.isNavigateFromLifeEvent) {
      setCurrentTab(pageMenuFromLifeCalendar?.menuItem);

      if (
        !pageMenuFromLifeCalendar?.currentServices &&
        pageMenuFromLifeCalendar?.pregnancyId
      ) {
        previousPregnancyLoadedFromLifeCalRef.current = true;
        (async () => {
          try {
            const pregnancyRegDetails: any = await fetchPregnancyDetailsByPregnancyId(
              pageMenuFromLifeCalendar.pregnancyId,
              true,
            );
            if (pregnancyRegDetails?.data?.[0]) {
              dispatch(
                updateAncService('viewPregnancyDetails', pregnancyRegDetails.data[0]),
              );
            }
          } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error);
          }
        })();
      }
    } else if (previousPregnancyLoadedFromLifeCalRef.current) {
      previousPregnancyLoadedFromLifeCalRef.current = false;
      const ongoingPregnancyId = beneficiaryPregnancyHistory?.data?.[0]?.pregnancy_id;
      if (ongoingPregnancyId) {
        (async () => {
          try {
            const pregnancyRegDetails: any = await fetchPregnancyDetailsByPregnancyId(
              ongoingPregnancyId,
              true,
            );
            if (pregnancyRegDetails?.data?.[0]) {
              dispatch(
                updateAncService('viewPregnancyDetails', pregnancyRegDetails.data[0]),
              );
            }
          } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error);
          }
        })();
      }
    }
  }, [pageMenuFromLifeCalendar]);

  useEffect(()=>{
    if(isPregnant){
      fetchBenfDetails(false);
    }
  },[isPregnant])

  const handleChildOverview = async () => {
    try {
      setLoading(true);
      if (ancPregBackObj) {
        setCurrentTab(ancPregBackObj?.menuItems);
      }
      const benfType = await fetchBenfDetails(false);
      if (
        ancPregBackObj?.menuItems === benfTabs.overview &&
        benfType === COMMON_CONSTANTS.CHILD
      ) {
        fetchChildDetails();
        fetchBenfImageDetails();
      }
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
    } finally {
      setLoading(false);
    }
  };

  const fetchInitialData = async (fromAnotherModule: boolean) => {
    try {
      setLoading(true);
      const benfType = await fetchBenfDetails(fromAnotherModule);
      if (benfType === COMMON_CONSTANTS.CHILD) {
        fetchChildDetails();
      } else {
        dispatch(updateChild('isChild', false));
        fetchRelavantDetails();
      }
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
    } finally {
      setLoading(false);
    }

    fetchBenfImageDetails();
  };

  const fetchChildDetails = async () => {
    try {
      const childResponse = await getData<any>(
        `${endpoints.childBeneficiaryById}/${id}`,
      );
      dispatch(updateChildDetails(childResponse?.data[0]));
      dispatch(updateChild('isChild', true));
      dispatch(updateChild('isKYCVerified', childResponse?.data?.[0].is_kyc_verified));
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
    }
  };
  
  const fetchBenfDetails = async (fromAnotherModule: boolean) => {
    const storeData:any={};
    storeData.data=benfDetails;
    const response =benfDetails?.length>0 && !fromAnotherModule && benfDetails[0]?.benef_id ==id ?storeData   : await getData<any>(
      `${endpoints?.getBeneficiaryById}/${id}`,
    );
    setBeneficiaryViewProp((prevState:any)=>({
      ...prevState,
      beneficiaryDetails: response,
    }))
    if (response.data?.length === 0) {
      setShowUnauthorized(true);
    } else {
      setShowUnauthorized(false);
      setBeneficiary(response?.data?.length > 0 ? response?.data[0] : null);
      dispatch(setBeneficiaryDetails(response?.data));
      setBenefDeathDetails(response.data);
      dispatch(setBenfDeathDetails(response.data));
      dispatch(setIsHRP(response?.data[0]?.is_hrp||isHRP));
    }
    setBeneficiaryType(response?.data?.[0]?.benf_type_name);
    return response?.data?.[0]?.benf_type_name;
  };
  const fetchHRPStatusByPregnancyId = async (pregnancyId: any, callAPI: boolean) => {
    const hprResponse: any = hrpStatus?.data?.length>0 && callAPI ? hrpStatus : await getData<any>(
      `${endpoints.getHRPStatus}/${pregnancyId}`,
    );
    dispatch(setHrpStatus(hprResponse));
    if (
      hprResponse?.data?.length > 0 &&
      hprResponse?.data[0]?.get_hrp_status
    ) {
      dispatch(setIsHRP(true));
    } else {
      dispatch(setIsHRP(false));
    }
  }
  const fetchPregnancyDetailsByPregnancyId = async (
  pregnancyId: any,
  forceAPI: boolean,
) => {
  try {
    const cachedPregnancyMatches =
      benefPregnancyDetails?.pregnancyId === pregnancyId &&
      benefPregnancyDetails?.data?.length > 0;

    const pregnancyRegDetails: any =
      cachedPregnancyMatches && !forceAPI
        ? benefPregnancyDetails
        : await getData(
            `${endpoints.getPregnancyDetailsById}/${pregnancyId}`,
          );

    const pregnancyDetailsWithId = {
      ...pregnancyRegDetails,
      pregnancyId,
    };

  if (!cachedPregnancyMatches || forceAPI) {
    dispatch(setPregnancyDetails(pregnancyDetailsWithId));
  }
    return pregnancyDetailsWithId;
  } catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error);
  }
};


const fetchObstetricHistory = async () => {
  try {
    // reuse store copy for THIS beneficiary; skip network on remount
    if (
      beneficiaryObstetricHistory?.benefId === id &&
      Array.isArray(beneficiaryObstetricHistory?.data)
    ) {
      setObstetricHistoryData(beneficiaryObstetricHistory.data);
      return;
    }

    const response = await getDataWithCache<any>(
      `${endpoints.getObestetricHistoryBeneficiary}/${id}`,
    );

    setObstetricHistoryData(response?.data || []);
    // persist so a back-navigation remount reuses it instead of refetching
    dispatch(
      setBeneficiaryObstetricHistory({ benefId: id, data: response?.data || [] }),
    );
  } catch (error: any) {
    errorLogger(error?.response?.data || error?.response || error);
  }
};

  const fetchRelavantDetails = async () => {
    await fetchObstetricHistory();
    const isBeneficiaryHistoryStored = beneficiaryPregnancyHistory?.data?.length > 0;
    const pregnancyDetails: any = isBeneficiaryHistoryStored ? beneficiaryPregnancyHistory : await getData(
      `${endpoints?.getPregnancyHistory(id)}`,
    );
    dispatch(setBeneficiaryPregnancyHistory(pregnancyDetails));
    const benefPregnancyDetailToView={
      pregnancyHistoryDetails: pregnancyDetails,
      pregnancyDetails: null,
    }
    setIsHRPStatusUseEffectTrigger(true);
    // 'previous_pregnancy' is historical obstetric data captured during another pregnancy's registration, not a trackable/ongoing pregnancy
    const isOngoingPregnant =
      pregnancyDetails?.data?.length &&
      pregnancyDetails?.data[0]?.module_code !== PNC_COMMON_CONSTANTS.CLOSE_PREGNANCY &&
      pregnancyDetails?.data[0]?.module_code !== PNC_COMMON_CONSTANTS.AUTO_CLOSURE_PREGNANCY &&
      pregnancyDetails?.data[0]?.module_code !== PNC_COMMON_CONSTANTS.ABORTION_DETAILS &&
      pregnancyDetails?.data[0]?.module_code !== PNC_COMMON_CONSTANTS.PREVIOUS_PREGNANCY;
    dispatch(setIsPregnant(isOngoingPregnant));
    const selectedPregnancyIdFromLifeCal =
      pageMenuFromLifeCalendar?.isNavigateFromLifeEvent &&
      !pageMenuFromLifeCalendar?.currentServices &&
      pageMenuFromLifeCalendar?.pregnancyId
        ? pageMenuFromLifeCalendar.pregnancyId
        : null;
    const pregnancyId = selectedPregnancyIdFromLifeCal || pregnancyDetails?.data?.[0]?.pregnancy_id;
    const forceFetchPregnancyDetails = !!selectedPregnancyIdFromLifeCal;
    if (pregnancyId) {
      isOngoingPregnant ? await fetchHRPStatusByPregnancyId(pregnancyId,isBeneficiaryHistoryStored): dispatch(setIsHRP(false));
      const pregnancyRegDetails: any = await fetchPregnancyDetailsByPregnancyId(pregnancyId, forceFetchPregnancyDetails);
      benefPregnancyDetailToView.pregnancyDetails = pregnancyRegDetails;
      dispatch(
        updateAncService('viewPregnancyDetails', pregnancyRegDetails?.data[0]),
      );
    }
    setBeneficiaryViewProp({
      ...beneficiaryViewProp,
      ...benefPregnancyDetailToView,
    });
  };

  const fetchBenfImageDetails = async () => {
    try {
      if (
        beneficiaryImage?.beneficiaryId === id &&
        beneficiaryImage?.isLoaded
      ) {
        setImageURL(
          beneficiaryImage?.imageURL || ''
        );
        return;
      }

      const res = await getData<any>(
        `${endpoints.getImageByBeneficiaryID(id)}`
      );

      const imageURL = res?.data?.[0]?.image
        ? convertByteToImageURL(
          res.data[0].image.data
        )
        : '';

      if (
        beneficiaryImage?.imageURL &&
        beneficiaryImage.imageURL !== imageURL
      ) {
        URL.revokeObjectURL(
          beneficiaryImage.imageURL
        );
      }

      dispatch(
        setBeneficiaryImage({
          beneficiaryId: id,
          imageURL,
          isLoaded: true,
        })
      );

      setImageURL(imageURL);
    } catch (error: any) {
      errorLogger(
        error?.response?.data ||
        error?.response ||
        error
      );
    }
  };

  useEffect(() => {
    const fetchData = async () => {
        const benefType= await fetchBenfDetails(true);
        const pregnancyDetails =  await getData<any>(
          `${endpoints.getPregnancyHistory(id)}`,
        );
        dispatch(setBeneficiaryPregnancyHistory(pregnancyDetails));
        const selectedPregnancyIdFromLifeCal =
          pageMenuFromLifeCalendar?.isNavigateFromLifeEvent &&
          !pageMenuFromLifeCalendar?.currentServices &&
          pageMenuFromLifeCalendar?.pregnancyId
            ? pageMenuFromLifeCalendar.pregnancyId
            : null;
        const targetPregnancyId = selectedPregnancyIdFromLifeCal || pregnancyDetails?.data[0]?.pregnancy_id;
        const pregnancyRegDetails: any = targetPregnancyId && await fetchPregnancyDetailsByPregnancyId(targetPregnancyId, false);
         setBeneficiaryViewProp((prevState:any)=>({
          ...prevState,
          pregnancyHistoryDetails: pregnancyDetails,
          pregnancyDetails: pregnancyRegDetails || prevState.pregnancyDetails,
        }))
        if (
          pregnancyDetails?.data?.length &&
          pregnancyDetails.data[0].module_code !== PNC_COMMON_CONSTANTS.CLOSE_PREGNANCY &&
          pregnancyDetails.data[0].module_code !== PNC_COMMON_CONSTANTS.AUTO_CLOSURE_PREGNANCY &&
          pregnancyDetails.data[0].module_code !== PNC_COMMON_CONSTANTS.ABORTION_DETAILS &&
          pregnancyDetails.data[0].module_code !== PNC_COMMON_CONSTANTS.PREVIOUS_PREGNANCY
        ) {
          const hprResponse: any =  await getData<any>(
            `${endpoints.getHRPStatus}/${pregnancyDetails?.data[0]?.pregnancy_id}`,
          );
          dispatch(setHrpStatus(hprResponse));
          if (
            hprResponse?.data?.length > 0 &&
            hprResponse?.data[0]?.get_hrp_status
          ) {
            dispatch(setIsHRP(true));
          } else {
            dispatch(setIsHRP(false));
          }
        } else {
          dispatch(setIsHRP(false));
        }
    };
    isHRPStatusUseEffectTrigger && fetchData();
  }, [checkIsHRP]);

  useEffect(() => {}, [newImageUrl]);
  const updateHandlerUpdate = () => {
    if (isChild) {
      childEditRef.current?.handleUpdateSave();
    } else if (childRef.current) {
      childRef.current.handleUpdateSave();
    }
  };

  useEffect(() => {
    return setInputField(false);
  }, []);
  const handleClick = () => {
    setInputField(true);
    inputRef.current?.click();
  };
  const onClose = () => {
    setInputField(false);
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const selectedFile = event.target.files && event.target.files[0];
    setImageError('');
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (fileSize > 1048576) {
        setImageError('File size must be less than or equal to 1MB');
        return;
      }
      if (!['image/jpeg', 'image/png', 'image/jpg'].includes(fileType)) {
        setImageError('Only JPG, JPEG and PNG images are allowed');
        return;
      }
      setNewImageUrl(URL.createObjectURL(selectedFile));
      const file = selectedFile;
      const formData = new FormData();
      formData.append('file', file);
      dispatch(imageData(formData));
    }
  };

  const handleProfilePicSubmit = async () => {
    if (newImageUrl !== '') {
      dispatch(isImageEdited(true));
    }
    onClose();
  };

  const handleNavClick = async (value: any, type: string) => {
    if (type === 'header') {
      dispatch(setAncPregBackHandler(null));
      dispatch(setFamilyPlanningBackHandler(null));
    } else if (type === 'content') {
      dispatch(setAncPregBackHandler(null));
      dispatch(setFamilyPlanningBackHandler(null));
      dispatch(updateAncService('selectedAncService', []));
    }
    setCurrentTab(value);
    dispatch(setLifeCalendarPageMenu(null));
  };

  const filteredMenu = useMemo(() => {
    if (!beneficiaryAllDetails) return [];
    const menuItems = beneficiariesTabs.filter((el: any) => {
      const isFemaleWithAbhaId = beneficiaryAllDetails?.gender_name === GENDER.FEMALE && beneficiaryAllDetails?.abha_id != null;
      if (
        ((el.label == benfTabs.pregnancyServices ||
          el.label == benfTabs.mcpCard ||
          el.label == benfTabs.hrpTracking ||
          el.label === benfTabs.referral ||
          el.label === benfTabs.JSSK) &&
          beneficiaryAllDetails?.gender_name === GENDER.MALE) ||
        (el.label === benfTabs.referral && !canViewServices) || 
        (el.label === benfTabs.LIFE_CALENDAR && !canViewBenf) ||
        (el.label === benfTabs.LIFE_CALENDAR && beneficiaryAllDetails?.gender_name === GENDER.MALE) ||
        (el.label === benfTabs.POSHAN && !(isFemaleWithAbhaId))
      )
        return false;
      return true;
    });

    if (beneficiary?.benf_type_name === COMMON_CONSTANTS.CHILD) {
      const hasAbhaIdOrBalAbhaId = (beneficiaryAllDetails?.abha_id != null || beneficiaryAllDetails?.bal_abha_id != null);
      return childTabs?.filter((item: any) => {
        if (item?.label === benfTabs.POSHAN && !hasAbhaIdOrBalAbhaId) {
          return false;
        }
        if (item?.label === benfTabs.JSSK) {
          return false;
       }
        return true;
      }).map((item: any) => {
        if (item?.label == benfTabs.mcpCard) {
          beneficiaryAllDetails?.enable_mcp_card === true
            ? (item['enable'] = true)
            : (item['enable'] = false);
        }
        return item;
      });
    } else {
      return beneficiary?.gender_name !== GENDER.MALE
        ? menuItems?.map((item: any) => {
            if (item?.label == benfTabs.mcpCard) {
              beneficiaryAllDetails?.enable_mcp_card === true
                ? (item['enable'] = true)
                : (item['enable'] = false);
            } else if (item?.label == benfTabs.hrpTracking) {
              beneficiaryAllDetails?.is_pregnant === true
                ? (item['enable'] = true)
                : (item['enable'] = false);
            } else if (item?.label == benfTabs.referral) {
              decodedUserData?.user_status === 'Active'
                ? (item['enable'] = true)
                : (item['enable'] = false);
            }
            return item;
          })
        : menuItems;
    }
  }, [beneficiaryAllDetails, beneficiary, childDetails]);

  const renderContent = () => {
    switch (currentTab) {
      case benfTabs.pregnancyServices:
        return <PregnancyTracking />;
      case benfTabs.childTracking:
        return canViewChild ? (
          <ChildList />
        ) : (
          <h2 style={{ padding: '20px' }}>Unauthorized</h2>
        );
      case benfTabs.mcpCard:
        return (
          <MCPCardDetails
            beneficiaryDetails={
              beneficiary?.benf_type_name === COMMON_CONSTANTS.CHILD
                ? childDetails
                : beneficiary
            }
            benefType={beneficiary?.benf_type_name}
          />
        );
      case benfTabs.hrpTracking:
        return <HRPTracking />;
      case benfTabs.familyPlanning:
        return <FamilyPlanning />;
      case benfTabs.referral:
        return <ReferralOverview />;
      case benfTabs.SERVICES:
        return <ChildServices />;
      case benfTabs.IMMUNIZATION:
        return <ChildImmunization />;
      case benfTabs.LIFE_CALENDAR:
        return <LineCalendarComponent />;
      case benfTabs.FACILITY_REFERRAL:
        return <></>;
      case benfTabs.POSHAN:
        return <PoshanComponent/>;
      case benfTabs.JSSK:
        return <JSSKServices/>;
      default:
        return flow === 'view' ? (
          beneficiary?.benf_type_name === COMMON_CONSTANTS.CHILD ? (
            <ChildDetailsView
              currentChild={childDetails}
              beneficiary={beneficiary}
              flow={flow}
            />
          ) : (
            <BeneficiaryView beneficiaryViewProp={{...beneficiaryViewProp,obstetricHistoryData}} />
          )
        ) : beneficiary?.benf_type_name === COMMON_CONSTANTS.CHILD ? (
           
           <ChildBeneficiaryEdit ref={childEditRef}
            currentChild={childDetails}
            beneficiaryDetails={beneficiary}
            flow={flow}
          />

        ) : (
          <BeneficiaryEdit ref={childRef} beneficiaryDetails={beneficiary} />
        );
    }
  };

  const formatGenderText = (genderName: string): string => {
    return genderName === GENDER.FEMALE ? GENDER.FEMALE : GENDER.MALE;
  };
  const handleBackButton = () => {
    if(beneficiary?.benf_type_name === COMMON_CONSTANTS.CHILD && throughParentProfile) {
      navigateWithMenuItem(`/beneficiaries/view/${childDetails?.parent_id}`, 'Child Tracking');
    } else {
      dispatch(setAncPregBackHandler(null));
      if (eventExecution?.goToServices?.isFromVhnd) {
        navigate('/vhnd-uhnd-execution');
        dispatch(setListPageType('sessionStarted'));
        dispatch(setShowDueList(true));
        dispatch(setShowDueListFromMainPage(true));
      } else if (workPlan?.goToBenefDetailPage?.isFromWorkPlan) {
        navigate('/workplan');
      } else {
          if(throughReferralModule) {
            navigate('/referralModule')
          }
          else {
            navigate('/beneficiaries')
            beneficiaryReduxStoreRemovalUtils(dispatch);
          }
      }
    }
    if (beneficiaryImage?.imageURL) {
      URL.revokeObjectURL(
        beneficiaryImage.imageURL
      );
    }
    dispatch(setBeneficiaryImage({}));
    dispatch(updateChild('throughParentProfile', false));
    dispatch(setReferralModule('throughReferralModule', false));
      setBackButtonClicked(true); 
      dispatch(isImageEdited(false));
      dispatch(setFamilyPlanningBackHandler(null));
      dispatch(updateAncService('selectedAncService', []));
      dispatch(updatePNC('pncOnSameDay', false));
      dispatch(setShowPregnancy(false));
      dispatch(setShowServices(false));
      dispatch(setPregnancyOngoing(false));
      dispatch(updateAncService('currPregnancyId', ''));
      dispatch(setIsHRP(false));
      dispatch(updateChildVerifyFromGrid(false));
      dispatch(updateChild("updateChildVerifyFromView", false));
      dispatch(setBeneficiaryDetails([]));
      dispatch(updateAncService('viewPregnancyDetails', []));
      dispatch(setIsPregnant(false));
      dispatch(updateForm('file', null));
      dispatch(setLifeCalendarPageMenu(null));
      dispatch(updateChild('isKYCVerified', false)); 
      dispatch(setBeneficiaryPregnancyHistory([]));
      dispatch(setBeneficiaryObstetricHistory(null));
      dispatch(setChildBenefList([]));  
  };

  return (
    <>
      {showUnauthorized ? (
        <Unauthorised />
      ) : (
        <div>
          <div className="app-child-wrapper">
            <header className="view-header">
              <div className="logo-wrapper">
                <NationalEmblem />
                <div className="name-wrapper">
                  <div className="name-wrapper-title">
                    JANANI
                  </div>
                  <div className="name-wrapper-subtext">
                    Journey of Antenatal, Natal and Neonatal Integrated Care
                  </div>
                  <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>
                    Sehat ke Sath, Every Step of Care
                  </div>
                </div>
              </div>
              <div className="view-route">
                <BreadcrumbComponent
                  breadcrumbItemName={[
                    { value: page, label: 'Service Provider' },
                    { value: page, label: 'Beneficiary Profile' },
                  ]}
                />
              </div>
            </header>
            <main className="view-content">
              <div className="view-profile-buttons">
                <div className="view-profile">
                  <CommonHamburgar>
                    <LeftNavBarCommon
                      navItems={filteredMenu}
                      currentTab={currentTab}
                      handleNavClick={(value: any) =>
                        handleNavClick(value, 'header')
                      }
                    />
                  </CommonHamburgar>
                  <div>
                    <Button
                      onClick={handleBackButton}
                      disabled={false}
                      id=""
                      buttonName={''}
                      colorType={'verticalbackbutton'}
                      icon={<BackArrowsvg />}
                      iconPosition={'left'}
                    />
                  </div>
                  <div className="profile-pic">
                    {newImageUrl === '' && imageURL !== '' ? (
                      <img
                        className={`profile-picture ${benefDeathDetails?.[0]?.is_dead || beneficiary?.is_dead ? 'black-white' : ''}`}
                        src={imageURL}
                        alt="Profile Image"
                      />
                    ) : newImageUrl !== '' ? (
                      <img
                        className={`profile-picture ${benefDeathDetails?.[0]?.is_dead || beneficiary?.is_dead ? 'black-white' : ''}`}
                        src={newImageUrl}
                        alt="Profile Image"
                      />
                    ) : (
                      <img
                        className={`profile-picture ${benefDeathDetails?.[0]?.is_dead || beneficiary?.is_dead ? 'black-white' : ''}`}
                        src={profilePic}
                        alt="Profile Image"
                      />
                    )}
                    {flow === 'edit' && (
                      <div className="edit-pencil-icon">
                        <div className="button_beneficiary_component">
                          <button
                            type="button"
                            onClick={
                              !benefDeathDetails?.[0]?.is_dead
                                ? () => handleClick()
                                : () => {}
                            }
                            id={''}
                            className={`adding_the_dynamic_button primary`}
                          >
                            <span className="button_icon_iconposition">
                              <Pencil />
                            </span>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="beneficiary-details">
                    <div className="name-type">
                      <div className="preg-badge">
                        <div className="benf-name">
                          {`${beneficiaryUpdateDetails?.name ? beneficiaryUpdateDetails?.name : beneficiary?.benf_name ? beneficiary?.benf_name : beneficiaryAllDetails?.benf_name}`}
                        </div>
                        {!beneficiary?.abha_id && (
                          <BadgesComponent
                            className="beneficiary-status"
                            badgeName={'Temporary'}
                            variant={'warning'}
                            badgeType="case5"
                          />
                        )}
                        {beneficiary?.is_pregnant && isPregnant && !isHRP ? (
                          <BadgesComponent
                            className="beneficiary-status"
                            badgeName={'Pregnant'}
                            variant={'success'}
                            badgeType="case5"
                          />
                        ) : null}
                        {beneficiary?.is_pregnant &&
                          beneficiary?.gender_name === 'Female' &&
                          isHRP &&
                          !benefDeathDetails?.[0]?.is_dead && (
                            <BadgesComponent
                              className="beneficiary-status"
                              badgeName={'HRP'}
                              variant={'danger'}
                              badgeType="case5"
                            />
                          )}
                       {beneficiary?.benf_type_name === COMMON_CONSTANTS.CHILD &&
                          (benefDeathDetails?.[0]?.is_dead || childDetails?.is_dead) && (
                            <BadgesComponent
                              className="beneficiary-status"
                              badgeName={'Deceased'}
                              variant={'danger'}
                              badgeType="case5"
                            />
                          )}
                        
                        {beneficiary?.benf_type_name !== COMMON_CONSTANTS.CHILD &&
                          benefDeathDetails?.[0]?.is_dead && (
                            <BadgesComponent
                              className="beneficiary-status"
                              badgeName={'Deceased'}
                              variant={'danger'}
                              badgeType="case5"
                            />
                          )}
                      </div>
                    </div>
                    {beneficiary?.benf_type_name === COMMON_CONSTANTS.CHILD ? (
                      <div className="beneficiary-address-details">
                        <div className="gender-class">
                          {`${formatMonthText(Math.floor(dayjs().diff(dayjs(childDetails?.dob), 'month', true)))}, ${formatGenderText(childDetails?.gender_name)}`}
                        </div>
                        {childDetails?.bal_abha_id ? (
                          <div>
                            Bal ABHA No :{' '}
                            <span className="value-text">
                              {childDetails?.bal_abha_id}
                            </span>
                          </div>
                        ) : (
                          ''
                        )}
                        {childDetails?.dob ? (
                          <div>
                            D.O.B :{' '}
                            <span className="value-text">
                              {desiredFormatDate(
                                childDetails?.dob,
                                dateFormate['dd/mm/yyy'],
                              )}
                            </span>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    ) : (
                      <div className="beneficiary-address-details">
                        <div className="gender-class">
                          {`${diffInYears(desiredFormatDate(beneficiaryUpdateDetails?.dob ? beneficiaryUpdateDetails?.dob : beneficiary?.dob, dateFormate.dd_mm_yyyy))} yrs, ${formatGenderText(beneficiary?.gender_name)}`}
                        </div>
                        {beneficiary?.abha_id ? (
                          <div>
                            ABHA No :{' '}
                            <span className="value-text">
                              {beneficiary?.abha_id}
                            </span>
                          </div>
                        ) : (
                          ''
                        )}
                        {beneficiary?.mob ? (
                          <div>
                            Mobile No :{' '}
                            <span className="value-text">
                              {beneficiaryUpdateDetails?.primaryMob ? beneficiaryUpdateDetails?.primaryMob : beneficiary?.mob}
                            </span>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="profile-header-outer">
                  {beneficiary?.is_pregnant &&
                    beneficiary?.benf_type_name !== COMMON_CONSTANTS.CHILD && (
                      <div className="profile-header-inner">
                        {viewPregnancyDetails?.lmp && isPregnant ? (
                          <div>
                            LMP :{' '}
                            <span className="value-text">
                              {desiredFormatDate(
                                viewPregnancyDetails?.lmp,
                                dateFormate['dd/mm/yyy'],
                              )}
                            </span>
                          </div>
                        ) : (
                          ''
                        )}
                        {viewPregnancyDetails?.lmp && isPregnant ? (
                          <div>
                            EDD :{' '}
                            <span className="value-text">
                              {AddDaystoDate(
                                viewPregnancyDetails?.lmp,
                                280,
                                dateFormate['dd/mm/yyy'],
                              )}
                            </span>
                          </div>
                        ) : (
                          ''
                        )}
                        {viewPregnancyDetails?.lmp && isPregnant ? (
                          <div className="weeks-container">
                            {getOrdinalSuffix(viewPregnancyDetails?.completed_weeks_of_pregnancy)} week
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    )}
                </div>
              </div>
              <div className="content">
                <LeftNavBarCommon
                  navItems={filteredMenu}
                  currentTab={currentTab}
                  handleNavClick={(value: any) =>
                    handleNavClick(value, 'content')
                  }
                />

                <div
                  className={`tab-content ${currentTab === 'Child Tracking' ? 'child_tracking' : ''}`}
                >
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div></div>
                    <div>
                      <BenificiaryActions
                        flow={flow}
                        loading={loading}
                        beneficiary={beneficiary}
                        updateHandlerUpdate={updateHandlerUpdate}
                        benefDeathDetails={benefDeathDetails}
                        id={id}
                        currentTab={currentTab}
                        childDetail={childDetails}
                      />
                    </div>
                  </div>
                  {!loading ? (
                    <>{renderContent()}</>
                  ) : (
                    <div className="loader">Loading...</div>
                  )}
                </div>
              </div>
            </main>
          </div>
          {closeModal && <CloseModal showModal={true} />}
          {inputField && (
            <ProfilePicUpdateModal
              showModal={inputField}
              onClose={onClose}
              modalTitle="Update Beneficiary Profile Picture"
              imageUrl={newImageUrl !== '' ? newImageUrl : imageURL}
              handleFileChange={handleFileChange}
              handleProfilePicSubmit={handleProfilePicSubmit}
              imageError={imageError}
              inputRef={inputRef}
            />
          )}
        </div>
      )}
    </>
  );
};

export default WomenComponent;
